import {Component, inject, Input} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatDialog} from "@angular/material/dialog";
import {PermissionsService} from "../../services/permissions.service";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {EmailBlastComponent} from "../dialogs/email-blast/email-blast.component";
import {IEmailPlayersDialogData} from "../../interfaces/IEmailPlayersDialogData";

@Component({
  selector: 'app-email-players-button',
  standalone: true,
  imports: [MatButton, MatIcon],
  template: `
    @if (canEmailPlayers()) {
      <button mat-stroked-button class="margin-bottom-med" (click)="openEmailPlayers()" data-testid="email-players-button">
        <mat-icon>email</mat-icon>
        Email players
      </button>
    }
  `
})
export class EmailPlayersButtonComponent {
  @Input() gameId: string | null = null;
  @Input() lockGame = false;

  private matDialog = inject(MatDialog);
  private permissionsService = inject(PermissionsService);

  // Judged on the game the view shows, not the app's active game, which can be stale on a cross-game page.
  canEmailPlayers(): boolean {
    return this.gameId
      ? this.permissionsService.userHasPermissionForGame(PermissionTypes.SendEmailBlast, this.gameId)
      : this.permissionsService.userHasPermission(PermissionTypes.SendEmailBlast);
  }

  openEmailPlayers() {
    const data: IEmailPlayersDialogData = {gameId: this.gameId, lockGame: this.lockGame};
    this.matDialog.open(EmailBlastComponent, {data});
  }
}
